<a href="/dashboard"><img class="logo" [src]="tenantConfigService.mobileIconUrl" [alt]="tenantConfigService.config.productName + ' logo'" /></a>
<div *ngIf="showUser" class="user-bar">
  <span class="text-big-medium-secondary">{{ name }}</span>
  <span class="text-grey60">{{ role }}</span>
</div>
